import React from 'react';
import Hero from './components/Hero';
import WhyChooseUs from './components/WhyChooseUs';
import Services from './components/Services';
import About from './components/About';
import Process from './components/Process';
import Team from './components/Team';
import QuoteSection from './components/QuoteSection';
import Contact from './components/Contact';
import Gallery from './components/Gallery';
import Footer from './components/Footer';
import Header from './components/Header';
import WhatsAppWidget from './components/WhatsAppWidget';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Process />
        <Team />
        <WhyChooseUs />
        <QuoteSection />
        <Contact />
        <Gallery />
      </main>
      <Footer />
      <WhatsAppWidget />
    </div>
  );
}

export default App;